import React from 'react';
import { Calendar } from 'lucide-react';

export default function SocialMediaCalendar() {
  // Mock data for calendar events
  const events = [
    {
      date: '2024-03-15',
      posts: [
        {
          time: '10:00',
          platforms: ['instagram', 'facebook'],
          content: 'Découvrez notre nouvelle destination : Les Maldives ! 🌊✨',
        },
      ],
    },
    {
      date: '2024-03-20',
      posts: [
        {
          time: '15:30',
          platforms: ['instagram'],
          content: 'Les plus beaux couchers de soleil à Santorin 🌅',
        },
        {
          time: '18:00',
          platforms: ['facebook', 'youtube'],
          content: 'Guide complet : Visiter Dubai en famille 🌆',
        },
      ],
    },
  ];

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-medium">Calendrier des publications</h2>
        <div className="flex gap-4">
          <button className="text-gray-600 hover:text-gray-900">Aujourd'hui</button>
          <button className="text-gray-600 hover:text-gray-900">Semaine</button>
          <button className="text-gray-600 hover:text-gray-900">Mois</button>
        </div>
      </div>

      <div className="border rounded-lg">
        {/* En-tête du calendrier */}
        <div className="grid grid-cols-7 gap-px bg-gray-200">
          {['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'].map((day) => (
            <div key={day} className="bg-gray-50 p-2 text-center text-sm font-medium">
              {day}
            </div>
          ))}
        </div>

        {/* Corps du calendrier */}
        <div className="grid grid-cols-7 gap-px bg-gray-200">
          {Array.from({ length: 35 }).map((_, index) => (
            <div
              key={index}
              className="bg-white min-h-32 p-2"
            >
              <div className="text-sm text-gray-500">{index + 1}</div>
              {/* Exemple d'événement */}
              {index === 14 && (
                <div className="mt-1">
                  <div className="bg-blue-100 text-blue-800 text-xs p-1 rounded">
                    <div className="flex items-center">
                      <Calendar className="w-3 h-3 mr-1" />
                      <span>10:00</span>
                    </div>
                    <div className="truncate">Nouvelle destination</div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}